import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import Field from './Field';

export default class EditField extends Field {
  constructor(key, label = '', options = {}) {
    super(key, label, options);
    this.saved = false;
    this.loading = false;
    this.disabled = false;
    this.error = false;
    this.require = options.require;
    this.valid = true;
  }

  setSaved(saved = true, error = false, valid = true) {
    this.saved = saved;
    this.loading = false;
    this.disabled = false;
    this.error = error;
    this.valid = valid;
  }

  setLoading() {
    this.loading = true;
    this.disabled = true;
    this.error = false;
  }

  getValue(data) {
    return data ? data[this.key] : undefined;
  }

  getEditField(params) {
    return (
      <Stack gap="24px">
        <Stack gap="8px">
          <Text
            color="primary"
            component="p"
            size="xl"
            weight="medium"
          >
            {this.options.editQuestionData?.question}
          </Text>
          {this.options.editQuestionData?.comment && (
            <Text
              color="primary"
              component="p"
              size="lg"
            >
              {this.options.editQuestionData?.comment}
            </Text>
          )}
        </Stack>
        {this.options.editQuestionData?.form && this.options.editQuestionData?.form(this, params)}
      </Stack>
    );
  }
}
